import { Button, Card, Image, Text, AspectRatio } from "@chakra-ui/react"
import { useEffect, useState } from "react";
import _ from "lodash"
import { useNavigate } from "react-router";
import SingleProductPrice from "@/components/product/price/SingleProductPrice"

const ProductItem = ({ data }) => {

    const [calculatedPrice, setCalculatedPrice] = useState(0)
    const navigate = useNavigate();
    useEffect(() => {
        try {
            //show min price
            //var lst = data.variants.map(x => x.calculated_price?.calculated_amount ?? 0)
            // setCalculatedPrice(_.min(lst));

        } catch (error) {
            //console.log("dâa", error, data)
        }

    }, [data])

    const getImageSrc = (image) => {
        if (!image) {
            return "";
        }
        if (typeof image === "string") {
            return image;
        }
        return image.md_url || image.lg_url || image.sm_url || image.url || "";
    };

    const thumbnailSrc = getImageSrc(data?.thumbnail) || getImageSrc(data?.image);

    return (
        <div onClick={e => navigate(`/product/${data.id}`)}>

            <Card.Root maxW="sm" overflow="hidden">

                <AspectRatio maxW="400px" ratio={4 / 3}>
                    <Image src={thumbnailSrc}
                        alt={data.name} objectFit="cover" />
                </AspectRatio>

                <Card.Body style={{ padding: 6 }}>
                    <div style={{ height: 35, textOverflow: "ellipsis" }}>
                        <Card.Description>
                            <Text lineClamp="2">
                                {data.name}
                            </Text>


                        </Card.Description>
                    </div>
                    <SingleProductPrice price={data.min_price ?? data.original_price} originalPrice={data.original_price} />
                </Card.Body>
                {/* <Card.Footer gap="2">
        <Button variant="solid">Buy now</Button>
        <Button variant="ghost">Add to cart</Button>
      </Card.Footer> */}
            </Card.Root>
        </div>
    )
}


export default ProductItem;
